/* ============================================================
   PROP & GROW — FREE GIFT METER
   Fills as qualifying plants go in the cart, celebrates at the goal,
   adds the free gift in one tap. State comes from the pg-gift-promo
   section (Liquid), refreshed after every cart change.
   ============================================================ */
(() => {
  if (window.PGGiftPromo) return;
  window.PGGiftPromo = true;

  const root = document.querySelector('[data-pggp]');
  if (!root) return;

  const CFG = window.PGGiftPromoConfig || {};
  const GIFT = CFG.giftName || 'gift';
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const sectionId = root.dataset.sectionId;
  const endsAt = parseInt(root.dataset.ends, 10) * 1000 || 0;
  const variantId = root.dataset.variant;
  const onCart = root.dataset.template === 'cart';
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const meter = root.querySelector('[data-pggm]');
  const pill = root.querySelector('[data-pggm-toggle]');
  const pillText = root.querySelector('[data-pggm-pill-text]');
  const ring = root.querySelector('[data-pggm-ring]');
  const panel = root.querySelector('[data-pggm-panel]');
  const panelBody = root.querySelector('[data-pggm-body]');
  const tpl = root.querySelector('[data-pggm-template]');
  const confettiEl = root.querySelector('[data-pggm-confetti]');

  const KEY_CELEBRATED = 'pggm-celebrated';
  const KEY_DISMISSED = 'pggm-dismissed';
  const KEY_LAST = 'pggm-last'; // last amount seen, so an unlock that happens while changing pages still celebrates
  const ss = {
    get: k => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* ignore */ } },
    del: k => { try { sessionStorage.removeItem(k); } catch (e) { /* ignore */ } }
  };

  const readState = (scope) => {
    const el = (scope || root).querySelector('[data-pggp-state]');
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };
  let state = readState();
  if (!state) return;

  // ---------- money ----------
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency });
  const money = cents => fmt.format((cents || 0) / 100).replace(/\.00$/, '');

  // ---------- cards (floating panel + inline on cart / product pages) ----------
  const cards = [];
  const makeCard = host => {
    host.innerHTML = '';
    host.appendChild(tpl.content.cloneNode(true));
    const card = host.querySelector('.pggm-card');
    cards.push(card);
    return card;
  };
  makeCard(panelBody);
  document.querySelectorAll('[data-pggm-inline]').forEach(makeCard);

  const productLine = document.querySelector('[data-pggm-product]');

  // ---------- rendering ----------
  const status = s => {
    const t = s.threshold;
    const q = s.qualified;
    const left = Math.max(0, t - q);
    const pct = Math.max(0, Math.min(100, Math.round((q / t) * 100)));
    const unlocked = q >= t;
    const inCart = s.giftQty > 0;
    return { t, q, left, pct, unlocked, inCart };
  };

  const actionsHtml = st => {
    if (st.unlocked && !st.inCart) {
      return `<button type="button" class="pggm-btn pggm-btn--lime" data-pggm-add>Add my free ${GIFT} →</button>`;
    }
    if (st.unlocked && st.inCart) {
      return `<a class="pggm-btn" href="${ROOT}cart">${onCart ? 'Free at checkout ✓' : 'View cart'}</a>`;
    }
    return `<a class="pggm-btn" href="${CFG.shopUrl || ROOT + 'collections/in-stock'}">Shop plants</a>`;
  };

  const message = st => {
    if (st.unlocked && st.inCart) return `Your ${GIFT} is in your cart. It drops to $0 at checkout.`;
    if (st.unlocked) return `You did it! Add your free ${GIFT} to your cart.`;
    if (st.inCart) return `Your ${GIFT} is in your cart. Add ${money(st.left)} more in plants to make it free.`;
    if (st.q === 0) return `Add ${money(st.t)} in plants and a ${GIFT} comes free.`;
    if (st.pct >= 75) return `So close! Just ${money(st.left)} to go.`;
    if (st.pct >= 50) return `Over halfway there. ${money(st.left)} to go.`;
    return `Growing nicely. ${money(st.left)} to go.`;
  };

  const render = () => {
    const st = status(state);

    // pill
    ring.style.setProperty('--p', st.pct);
    meter.classList.toggle('is-unlocked', st.unlocked);
    meter.classList.toggle('is-claimed', st.unlocked && st.inCart);
    pillText.innerHTML = st.unlocked
      ? (st.inCart ? `<strong>Free ${GIFT}</strong> in cart ✓` : `<strong>Unlocked!</strong> Add your ${GIFT}`)
      : (st.q === 0 ? `<strong>Free ${GIFT}</strong> at ${money(st.t)}` : `<strong>${money(st.left)}</strong> to a free ${GIFT}`);

    cards.forEach(card => {
      card.classList.toggle('is-unlocked', st.unlocked);
      card.querySelector('[data-pggm-fill]').style.width = `${st.pct}%`;
      card.querySelector('[data-pggm-title]').textContent = st.unlocked ? `Free ${GIFT} unlocked! 🎉` : `Unlock a free ${GIFT}`;
      card.querySelector('[data-pggm-progress]').textContent = `${money(Math.min(st.q, st.t))} of ${money(st.t)} in plants`;
      card.querySelector('[data-pggm-msg]').textContent = message(st);
      card.querySelector('[data-pggm-actions]').innerHTML = actionsHtml(st);
    });

    if (productLine) {
      if (state.product === 'yes') {
        const after = Math.min(st.t, st.q + (state.productPrice || 0));
        const pctAfter = Math.round((after / st.t) * 100);
        productLine.hidden = false;
        productLine.innerHTML = st.unlocked
          ? `<span class="pggm-pl__icon">🎁</span><span>You've unlocked a free ${GIFT}. ${st.inCart ? 'It’s in your cart.' : `<button type="button" class="pggm-pl__link" data-pggm-add>Add it to your cart</button>`}</span>`
          : `<span class="pggm-pl__icon">🌱</span><span>This plant counts toward a free ${GIFT}. Adding it gets you to <strong>${pctAfter >= 100 ? 'unlocked 🎉' : `${pctAfter}%`}</strong>${pctAfter >= 100 ? '' : ` (${money(Math.max(0, st.t - after))} to go)`}.</span>`;
      } else if (state.product === 'gift') {
        productLine.hidden = false;
        productLine.innerHTML = st.unlocked
          ? `<span class="pggm-pl__icon">🎁</span><span>You've unlocked this one for free. Add it to your cart and it drops to $0 at checkout.</span>`
          : `<span class="pggm-pl__icon">🎁</span><span>Get this plant free when you spend ${money(st.t)} on other plants. You're ${money(st.left)} away.</span>`;
      } else {
        productLine.hidden = true;
      }
    }

    // floating meter visibility
    const dismissed = ss.get(KEY_DISMISSED) === String(state.itemCount);
    meter.hidden = onCart || dismissed;
  };

  // ---------- celebrate ----------
  const confetti = () => {
    if (reduceMotion || !confettiEl) return;
    const colors = ['#dff56b', '#1f6545', '#7fc27a', '#ffffff', '#f2c94c'];
    confettiEl.innerHTML = '';
    for (let i = 0; i < 70; i++) {
      const s = document.createElement('span');
      s.style.left = `${Math.random() * 100}%`;
      s.style.background = colors[i % colors.length];
      s.style.animationDelay = `${Math.random() * 0.4}s`;
      s.style.animationDuration = `${1.6 + Math.random() * 1.4}s`;
      s.style.setProperty('--x', `${(Math.random() - 0.5) * 240}px`);
      s.style.setProperty('--r', `${Math.random() * 720}deg`);
      confettiEl.appendChild(s);
    }
    confettiEl.classList.add('is-on');
    setTimeout(() => { confettiEl.classList.remove('is-on'); confettiEl.innerHTML = ''; }, 3400);
  };

  const openPanel = () => {
    if (onCart) {
      const inline = document.querySelector('[data-pggm-inline]');
      if (inline) { inline.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); return; }
    }
    ss.del(KEY_DISMISSED);
    meter.hidden = false;
    panel.hidden = false;
    meter.classList.add('is-open');
    pill.setAttribute('aria-expanded', 'true');
  };
  const closePanel = () => {
    panel.hidden = true;
    meter.classList.remove('is-open');
    pill.setAttribute('aria-expanded', 'false');
  };

  const maybeCelebrate = (prev, next) => {
    const was = prev && prev.qualified >= prev.threshold;
    const now = next.qualified >= next.threshold;
    if (now && !was && ss.get(KEY_CELEBRATED) !== '1') {
      ss.set(KEY_CELEBRATED, '1');
      openPanel();
      cards.forEach(c => { c.classList.remove('pop'); void c.offsetWidth; c.classList.add('pop'); });
      confetti();
    }
    if (!now) ss.del(KEY_CELEBRATED);
    if (prev && next.qualified > prev.qualified && !now) {
      meter.classList.remove('bump'); void meter.offsetWidth; meter.classList.add('bump');
    }
  };

  // ---------- refresh from server ----------
  let refreshing = null;
  const refresh = async () => {
    if (refreshing) return refreshing;
    refreshing = (async () => {
      try {
        const res = await fetch(`${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`, { credentials: 'same-origin' });
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = readState(doc);
        if (!next) return;
        const prev = state;
        state = next;
        render();
        maybeCelebrate(prev, next);
        ss.set(KEY_LAST, String(next.qualified));
        const bubble = document.querySelector('.pgh__cart-count');
        if (bubble) bubble.textContent = String(next.itemCount);
      } catch (e) { console.warn('[pg-gift-promo] refresh failed', e); }
      finally { refreshing = null; }
    })();
    return refreshing;
  };
  let refreshTimer = null;
  const refreshSoon = (ms = 250) => { clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, ms); };

  // Watch cart requests made by the theme (add to cart, quantity changes, removals)
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(() => refreshSoon(150)).catch(() => {});
    return p;
  };
  ['cart:updated', 'cart:refresh', 'cart-update', 'cart:change', 'product:added'].forEach(ev => document.addEventListener(ev, () => refreshSoon()));
  window.addEventListener('pageshow', e => { if (e.persisted) refresh(); });

  // ---------- add the gift ----------
  const addGift = async button => {
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const res = await origFetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (onCart) { window.location.reload(); return; }
      await refresh();
      openPanel();
    } catch (e) {
      if (button) { button.disabled = false; button.textContent = `Couldn't add it. Try again`; }
    }
  };

  // ---------- events ----------
  document.addEventListener('click', e => {
    const add = e.target.closest('[data-pggm-add]');
    if (add) { e.preventDefault(); addGift(add); return; }
    if (e.target.closest('[data-pggp-open]')) { e.preventDefault(); openPanel(); return; }
  });
  pill.addEventListener('click', () => (panel.hidden ? openPanel() : closePanel()));
  root.querySelector('[data-pggm-close]').addEventListener('click', () => {
    closePanel();
    ss.set(KEY_DISMISSED, String(state.itemCount)); // stays hidden until the cart changes
    meter.hidden = true;
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !panel.hidden) closePanel(); });

  // ---------- countdown ----------
  const timers = Array.from(document.querySelectorAll('[data-pggp-timer]'));
  const tick = () => {
    if (!endsAt) return;
    const ms = endsAt - Date.now();
    if (ms <= 0) { root.hidden = true; return; }
    const d = Math.floor(ms / 86400000);
    const h = Math.floor((ms % 86400000) / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    const txt = d > 0 ? `Ends in ${d}d ${h}h ${m}m` : `Ends in ${h}h ${m}m ${String(s).padStart(2, '0')}s`;
    timers.forEach(t => { t.textContent = txt; t.classList.toggle('is-urgent', d === 0); });
  };
  tick();
  setInterval(tick, 1000);

  render();
  const last = parseInt(ss.get(KEY_LAST) || '-1', 10);
  if (last >= 0) maybeCelebrate({ qualified: last, threshold: state.threshold }, state);
  ss.set(KEY_LAST, String(state.qualified));
  // The page may come from cache: make sure the meter matches the real cart.
  refreshSoon(600);
})();
